// src/components/KitExplorer/KitExplorer.tsx

import React, { useState, useRef, useEffect } from 'react';
import './KitExplorer.css';

interface Kit {
  id: string;
  name: string;
  category: string;
  title: string;
  description: string;
  audioUrl?: string;
  imageUrl: string;
  price?: string;
}

interface KitExplorerProps {
  kitsToDisplay: Kit[];
}

const KitExplorer: React.FC<KitExplorerProps> = ({ kitsToDisplay }) => {
  const [flippedCards, setFlippedCards] = useState(new Set<string>());
  const [playingKit, setPlayingKit] = useState<string | null>(null);
  const audioRef = useRef<HTMLAudioElement | null>(null);

  // ... (useEffect e outras funções permanecem os mesmos) ...
  
  const handleFlip = (kitId: string) => {
    setFlippedCards(prevFlipped => {
      const newFlipped = new Set(prevFlipped);
      if (newFlipped.has(kitId)) {
        newFlipped.delete(kitId);
      } else {
        newFlipped.add(kitId);
      }
      return newFlipped;
    });
  };
  
  const handlePlayPause = (kitId: string, audioUrl?: string) => {
    if (!audioRef.current || !audioUrl) return;

    if (playingKit === kitId) {
      audioRef.current.pause();
      setPlayingKit(null);
    } else {
      audioRef.current.src = audioUrl;
      audioRef.current.play();
      setPlayingKit(kitId);
    }
  };

  return (
    <div className="card-container">
      {kitsToDisplay.map((kit) => (
        <div
          className={`card-wrapper ${flippedCards.has(kit.id) ? 'is-flipped' : ''}`}
          key={kit.id}
        >
          <div className="card-inner">
            {/* ✅ CORREÇÃO: A imagem é aplicada via style, usando os dados do kit */}
            <div 
              className={`card ${kit.name} card-front`} 
              style={{ backgroundImage: `url(${kit.imageUrl})` }}
            >
              <div className="card-info">
                <h1 className="card-title">{kit.title}</h1>
                <h2 className="card-subtitle">Sound Kit</h2>
              </div>
            </div>
            <div className="card card-back">
              <h3>{kit.title}</h3>
              <p>{kit.description}</p>
            </div>
          </div>
          
          <button className="play-button" onClick={(e) => { e.stopPropagation(); handlePlayPause(kit.id, kit.audioUrl); }}>
            {playingKit === kit.id ? (
              <span className="material-symbols-outlined notranslate" translate="no">pause</span>
            ) : (
              <span className="material-symbols-outlined notranslate" translate="no">play_arrow</span>
            )}
          </button>
          
          <button 
            className="flip-button-to-back" 
            onClick={(e) => { e.stopPropagation(); handleFlip(kit.id); }}
            aria-label="Ver descrição"
          >
            <span className="material-symbols-outlined notranslate" translate="no">360</span>
          </button>
          
          <button 
            className="flip-button-to-front" 
            onClick={(e) => { e.stopPropagation(); handleFlip(kit.id); }}
            aria-label="Voltar para a frente"
          >
            <span className="material-symbols-outlined notranslate" translate="no">360</span>
          </button>
        </div>
      ))}
    </div>
  );
};

export default KitExplorer;